import { TableCell, Typography } from '@mui/material'

import type { EnergyBidStepSnapshot } from '@/features/bidding/types/bidDetail/EnergyBidSnapshot'
import { convertToRoundedMw } from '@/features/bidding/utils/calculations/convertToRoundedMw'

export type BidEnergyStepCellsProps = Readonly<{
  step: EnergyBidStepSnapshot
  dimmed?: boolean
}>

export default function BidEnergyStepCells({ step, dimmed = false }: BidEnergyStepCellsProps) {
  return (
    <>
      <TableCell align="center" sx={{ opacity: dimmed ? 0.5 : 1 }}>
        <Typography variant="body2">{formatPrice(step.offeredPrice)}</Typography>
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderRight: 1,
          borderRightColor: 'divider',
          opacity: dimmed ? 0.5 : 1,
        }}
      >
        <Typography variant="body2">{formatMw(step.offeredVolume.quantity)}</Typography>
      </TableCell>
    </>
  )
}

function formatPrice(eurPerMwh: number): string {
  return `${eurPerMwh.toFixed(2)} €/MWh`
}

function formatMw(watts: number): string {
  return `${convertToRoundedMw(watts).toFixed(2)} MW`
}
